import React, { Component } from 'react';
import { connect } from 'react-redux';
import { LoadingOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import { userLogout } from '../../../../slices/auth/login.thunks';
import { RootState } from '../../../../slices/rootReducer';
import {
  selectUpgradeAccountError,
  selectUpgradingToProState
} from '../../../../slices/upgradeAccount/upgradeToPro.selectors';
import { upgradeToProfessionalAccount } from '../../../../slices/upgradeAccount/upgradeToPro.thunk';

import styles from './upgradeToProPayment.module.scss';

interface IDispatchProps {
  userLogout: () => void;
  upgradeToProfessionalAccount: () => void;
}

interface IMapStateProps {
  upgradingToPro: boolean;
  error: string | null;
}

type Props = IDispatchProps & IMapStateProps;

class ConfirmPaymentSuccessBase extends Component<Props> {
  constructor(props: Props) {
    super(props);

    this.finishUpgrade = this.finishUpgrade.bind(this);
  }
  componentDidUpdate(prevProps: Readonly<Props>) {
    const { upgradingToPro, error } = this.props;

    if (!upgradingToPro && prevProps.upgradingToPro) {
      if (!error) {
        this.props.userLogout();
      }
    }
  }
  private finishUpgrade() {
    this.props.upgradeToProfessionalAccount();
  }

  render() {
    const { error, upgradingToPro } = this.props;
    if (error) {
      return <div>
        An error occurred while processing your upgrade. Click on the button to try again.
        If the problem persist please contact support
        <Button
          type='primary'
          disabled={upgradingToPro}
          loading={upgradingToPro}
          onClick={this.finishUpgrade}
        >
          Finish upgrade
        </Button>
      </div>;
    }

    return <div>
      <LoadingOutlined className={styles.paymentLoading} />
      We're upgrading your account, you will be logged out shortly, please login again in 1 to 10 minutes
    </div>;
  }
}

const mapStateToProps = (state: RootState): IMapStateProps => {
  return {
    upgradingToPro: selectUpgradingToProState(state),
    error: selectUpgradeAccountError(state)
  };
};

export const ConfirmPaymentSuccess = connect(mapStateToProps, {
  userLogout,
  upgradeToProfessionalAccount
})(ConfirmPaymentSuccessBase);
